export default __webpack_public_path__ + "static/media/green-points.4ccc6019.svg";